// extracted by mini-css-extract-plugin
export default {"terminalContainer":"TerminalPane_terminalContainer__MYznE"};